import { Component, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { CartService } from '../../../../shared/services/cart.service';
import { Router } from '@angular/router';
import { DataService } from 'src/shared/data/data.service';
     

@Component({
    selector: 'app-wishlist-page',
    templateUrl: './wishlist-page.component.html',
    styleUrls: ['./wishlist-page.component.scss']
})
export class WishlistPageComponent implements OnInit {

    // constructor() { }

    // ngOnInit(): void {
    // }

    // pageTitle = [
    //     {
    //         bgImage: 'assets/img/page-title-bg.jpg',
    //         title: 'Wishlist'
    //     }
    // ]

    wishlist: any[] = [];
    isLoggedIn: boolean = false;
    pageTitle = [
        {
            bgImage: 'assets/img/page-title-bg.jpg',
            title: 'Wishlist'
        }
    ];
    constructor(
        private http: HttpClient,
        private cartService: CartService,
        private router: Router,
        private data:DataService,
    ) { }
    ngOnInit(): void {
        this.isLoggedIn = localStorage.getItem('is_logged_in') === 'true';
        if (this.isLoggedIn) {
            this.loadWishlist();
        }
    }

    loadWishlist(): void {
        const customerId = localStorage.getItem('customer_id');
        this.http.post<any>( this.data.base_url+'get_wishlist/', {
            customer_id: customerId
        }).subscribe({
            next: (res) => {
                if (res.status === 1) {
                    this.wishlist = res.data.map((item: any) => ({
                        id: item.id,
                        title: item.product_name,
                        description: item.product_description,
                        price: item.mrp,
                        image: item.product_image,
                        stock: item.stock,
                        quantity: 1
                    }));

                     this.cartService.setCount(this.wishlist.length);
                }
            },
            error: (err) => console.error('Error fetching wishlist', err)
        });
    }

    
    removeFromWishlist(item: any): void {
        const customerId = localStorage.getItem('customer_id');
        this.http.post<any>(this.data.base_url+'toggle_wishlist/', {
            customer_id: customerId,
            product_id: item.id
        }).subscribe({
            next: (res) => {
                if (res.status === 1) {
                    this.wishlist = this.wishlist.filter(x => x.id !== item.id);
                    this.cartService.setCount(this.wishlist.length);
                  
                }
            },
            error: (err) => console.error('Error removing from wishlist', err)
        });
    } 
    
    // addToCart(item: any): void {
    //     this.cartService.addToCart(item);
    //     console.log('Item added to cart:', item);
    // }

addWishlistItemToCart(item: any): void {
  console.log("whishlist item",item)
  const customerId = localStorage.getItem('customer_id');

  this.http.post<any>(
    this.data.base_url + 'add_to_cart/',
    {
      customer_id: customerId,
      product_id: item.id,
      quantity: 1
    }
  ).subscribe({

    next: (res) => {

      if (res.status === 1) {

        // Refresh cart count
        this.cartService.loadCart();

        // Optional: Remove from wishlist after adding
        this.removeFromWishlist(item);

      }

    }

  });

}
}